module.exports = __webpack_public_path__ + "static/media/handlebars.bc9e95fc.png";